<template>
  <section id="services">
    <v-container>
      <div
        data-aos-duration="1500"
        data-aos="fade-down"
        class="
          mb-12
          text-h4 text-sm-h3
          font-weight-bold
          error--text
          text-center text--darken-3
        "
      >
        خدماتنا
      </div>
      <v-row>
        <v-col md="3" v-for="(item, itemInd) in items" :key="itemInd">
          <v-hover v-slot="{ hover }">
            <!-- :data-aos="itemInd == 0 || itemInd == 3 ? 'fade-up' : 'fade-down'" -->
            <v-card
              max-width="200"
              width="200"
              :data-aos="checkitemAnimation(itemInd)"
              data-aos-duration="1500"
              :data-aos-anchor-placement="
                itemInd == 0 || itemInd == 3 ? 'top-center' : 'bottom-bottom'
              "
              class="mx-auto"
              flat
              color="transparent"
              height="140"
            >
              <div class="flipper" :class="{ flip: hover }">
                <div class="front-card card rounded-12">
                  <div class="card-image rounded-12">
                    <div
                      class="
                        header-front
                        pa-3
                        d-flex
                        align-center
                        justify-center
                      "
                    >
                      <v-img
                        contain
                        :src="
                          require(`@/assets/imgs/DServices/${item.img}.png`)
                        "
                        height="140"
                        width="176"
                        max-width="176"
                      >
                      </v-img>
                    </div>
                  </div>
                </div>
                <div class="back-card card rounded-12">
                  <div class="card-image rounded-12">
                    <div class="header-back d-flex justify-center align-center">
                      <!-- <span class="card-title" v-html="item.title"> </span> -->
                      <span
                        class="px-2 white--text text-body-1 font-weight-bold"
                        v-html="item.title"
                      >
                      </span>
                    </div>
                  </div>
                  <!-- <div class="card-content ">
                    <p v-html="item.title"></p>
                  </div> -->
                </div>
              </div>
            </v-card>
          </v-hover>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  data: () => ({
    show: false,
    items: [
      {
        img: 1,
        title: "تسويق عبر منصات<br /> التواصل الاجتماعي",
      },
      {
        img: 2,
        title: "تصميم التطبيقات الالكترونية",
      },
      {
        img: 3,
        title: "تصميم مطبوعات",
      },
      {
        img: 4,
        title: "تصميم متاجر الكترونية",
      },
    ],
  }),
  computed: {
    checkitemAnimation() {
      return (itemInd) => {
        if (
          (itemInd == 0 || itemInd == 3) &&
          this.$vuetify.breakpoint.smAndUp
        ) {
          return "fade-up";
        }
        if (
          (itemInd == 1 || itemInd == 2) &&
          this.$vuetify.breakpoint.smAndUp
        ) {
          return "fade-down";
        }
        if ((itemInd == 0 || itemInd == 3) && this.$vuetify.breakpoint.xsOnly) {
          return "fade-right";
        }
        if ((itemInd == 1 || itemInd == 2) && this.$vuetify.breakpoint.xsOnly) {
          return "fade-left";
        }
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.rounded-12 {
  border-radius: 12px !important;
}
.hover-card {
  position: absolute;
}

.flipper {
  position: relative;
}

.flipper {
  perspective: 600px;
  -webkit-perspective: 600px;
  -moz-perspective: 600px;

  -webkit-transform-origin: 100% center;
  -moz-transform-origin: 100% center;
  -ms-transform-origin: 100% center;
  transform-origin: 100% center;
}

.front-card,
.back-card {
  -webkit-transform-style: preserve-3d;
  -moz-transform-style: preserve-3d;
  transform-style: preserve-3d;

  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  backface-visibility: hidden;

  -o-transition: transform 0.6s ease-in-out;
  -moz-transition: transform 0.6s ease-in-out;
  -webkit-transition: transform 0.6s ease-in-out;
  transition: transform 0.6s ease-in-out;

  position: absolute;
  top: 0;
  left: 0;
}

.front-card {
  z-index: 2;
  -webkit-transform: rotateX(0deg);
  -moz-transform: rotateX(0deg);
  transform: rotateX(0deg);
}
.flipper.flip .front-card {
  -webkit-transform: rotateX(180deg);
  -moz-transform: rotateX(180deg);
  transform: rotateX(180deg);
}

.back-card {
  -webkit-transform: rotateX(-180deg);
  -moz-transform: rotateX(-180deg);
  transform: rotateX(-180deg);
}

.flipper.flip .back-card {
  -webkit-transform: rotateX(0deg);
  -moz-transform: rotateX(0deg);
  transform: rotateX(0deg);
}

/*Styling*/
.header-front {
  // background: SteelBlue;
  background: #5e78ca;
}

.header-back {
  // background: YellowGreen;
  background: #5e78ca;
  max-width: 200px;
  min-width: 199px;
}

.card {
  margin-top: 10px;
  box-sizing: border-box;
  border-radius: 2px;
  background-clip: padding-box;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}
.card span.card-title {
  color: #fff;
  // font-size: 24px;
  font-weight: 300;
  text-transform: uppercase;
}

.card .card-image {
  position: relative;
  overflow: hidden;
}
.card .card-image .header-front,
.card .card-image .header-back {
  border-radius: 2px 2px 0 0;
  background-clip: padding-box;
  position: relative;
  z-index: -1;
  // width: 500px;
  height: 150px;
}
.card .card-image span.card-title {
  position: absolute;
  bottom: 0;
  left: 0;
  padding: 16px;
}
.card .card-content {
  padding: 16px;
  border-radius: 0 0 2px 2px;
  background-clip: padding-box;
  box-sizing: border-box;
}
.card .card-content p {
  margin: 0;
  color: inherit;
}
.card .card-content span.card-title {
  line-height: 48px;
}
</style>